// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"light":"fe7df0b4644613a13f89","dark":"ea8654deba25a9d85a19","styles":"933d9c238e770ce99e5d"}[chunkId] + ".css";
};